import { render, staticRenderFns } from "./Post_Button_Expand.vue?vue&type=template&id=46be49c5&scoped=true&"
import script from "./Post_Button_Expand.vue?vue&type=script&lang=js&"
export * from "./Post_Button_Expand.vue?vue&type=script&lang=js&"
import style0 from "./Post_Button_Expand.vue?vue&type=style&index=0&id=46be49c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46be49c5",
  null
  
)

export default component.exports